





























import Vue from 'vue';
import STooltip from '../STooltip/STooltip.vue';

export default Vue.extend({
  name: 'SSidebarLink',
  components: {
    STooltip,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: [String, Object],
      required: false,
    },
    exact: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    /**
     * When the menu is collapsed, show tooltips
     */
    showTooltips(): boolean {
      return !this.$store.state.sidebar.navDrawer;
    },
  },
});
